import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-magda-portal',
  templateUrl: './magda-portal.component.html',
  styleUrls: ['./magda-portal.component.scss']
})
export class MagdaPortalComponent implements OnInit {

  constructor(private titleService: Title) {
    this.titleService.setTitle("MAGDA PORTAL");
  }

  ngOnInit(): void {
  }
  slides = [
    { id: "https://hdl.handle.net/20.500.14428/63653", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img018.jpg", autor: "Magda Portal.", titulo: "Hacia la emancipación de la mujer,", ano: "1980" },
    { id: "https://hdl.handle.net/20.500.14428/65151", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img019.jpg", autor: "Magda Portal.", titulo: "Mujeres de nuestro tiempo,", ano: "1986" },
    { id: "http://hdl.handle.net/20.500.14428/79281", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img020.jpg", autor: "ALIMUPER.", titulo: "Pronunciamiento,", ano: "1979" },
    { id: "http://hdl.handle.net/20.500.14428/79282", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img021.jpg", autor: "Cecilia Bustamante.", titulo: "Las intelectuales peruanas de la generación de José Carlos Mariátegui,", ano: "1979" },
    { id: "https://hdl.handle.net/20.500.14428/65136", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img022.jpg", autor: "Magda Portal.", titulo: "Existencia o inexistencia de una literatura femenina,", ano: "1981" },
    { id: "http://hdl.handle.net/20.500.14428/79166", img: "/assets/images/micrositio/micrositio13/ET04_MS012_MAGDA_img023.jpg", autor: "Magda Portal.", titulo: "Flora Tristán, precursora.", ano: "Editorial La Equidad, 1983" },
  ];

  slideConfig =
    {
      "slidesToShow": 5, "slidesToScroll": 1, "responsive":
        [
          {
            'breakpoint': 600,
            'settings':
            {
              'slidesToShow': 1
            }
          }
        ]
    };



}
